const initialState = {
    agentName:undefined,
    data:[],
    clients:{}
  }

//   const CID=1427

//   initialState.data =[
//     {
//         "c_id": CID,
//         "data": "Hi!",
//         "date": new Date()
//     },
//     {
//         "c_id": CID,
//         "data": "Hi 701",
//         "date": new Date()
//     },
//     {
//         "c_id": CID,
//         "data": "How are you ?",
//         "date": new Date()
//     },
//     {
//         "c_id": CID,
//         "data": "I am Good How Are you ?",
//         "date": new Date()
//     },
// ]
  
  export default function filtersReducer(state = initialState, action) {
  
    switch (action.type) {

      case 'AGENT_JOINED': {

        //  ;
        let ns = {...state};

        if (action.data.name){
            ns.agentName = action.data.name;
        }

        if (action.data.email){
            ns.agentName = action.data.email.substring(0,action.data.email.indexOf("@"));
        }

        let nd = {...action.data};
        nd.renderName = ns.agentName;
        ns.clients[nd.cid]=nd;

        return ns;
    }
    case 'VIEWER_JOINED': {

        //  ;
        let ns = {...state};
        let nd = {...action.data};

        if (action.data.name){
            nd.renderName = action.data.name;
        }

        if (action.data.email){
            nd.renderName = action.data.email.substring(0,action.data.email.indexOf("@"));
        }

        ns.clients[nd.cid]=nd;

        return ns;
    }
    case 'CHAT_ADD': {

        let ns = {...state};

        let data = {... action.data}
        data.date= new Date();

        ns.data.push(data);

        return ns;
    }
    //   case 'filters/colorFilterChanged': {
    //     let { color, changeType } = action.payload
    //     const { colors } = state
  
    //     switch (changeType) {
    //       case 'added': {
    //         if (colors.includes(color)) {
    //           // This color already is set as a filter. Don't change the state.
    //           return state
    //         }
  
    //         return {
    //           ...state,
    //           colors: state.colors.concat(color),
    //         }
    //       }
    //       case 'removed': {
    //         return {
    //           ...state,
    //           colors: state.colors.filter(
    //             (existingColor) => existingColor !== color
    //           ),
    //         }
    //       }
    //       default:
    //         return state
    //     }
    //   }
      default:
        return state
    }
  }